export const _FAVOURTIES = {
    FETCH_FAVOURTIES_REQUEST : 'FETCH_FAVOURTIES_REQUEST',
    FETCH_FAVOURTIES_SUCCESS : 'FETCH_FAVOURTIES_SUCCESS',
    FETCH_FAVOURTIES_FAILURE : 'FETCH_FAVOURTIES_FAILURE',
    
    ADD_FAVOURITES_REQUEST : 'ADD_FAVOURITES_REQUEST',
    ADD_FAVOURITES_SUCCESS : 'ADD_FAVOURITES_SUCCESS',
    ADD_FAVOURITES_FAILURE : 'ADD_FAVOURITES_FAILURE',
    
    REMOVE_FAVOURITES_REQUEST : 'REMOVE_FAVOURITES_REQUEST',
    REMOVE_FAVOURITES_SUCCESS : 'REMOVE_FAVOURITES_SUCCESS',
    REMOVE_FAVOURITES_FAILURE : 'REMOVE_FAVOURITES_FAILURE',
}